export enum ComponentEnum {
    HOTSPOTS = "Hotspots",
    HOSTPOSTS360 = "360Hotspots"
}